import { useEffect, useState } from 'react';

const DEFAULT_TICK_MS = 30_000;

/**
 * Wall-clock tick: the current time, re-read every `intervalMs`. Lets a
 * label or icon that depends on "how long ago" move on its own —
 * countdowns, a delivery spinner whose grace period runs out — instead
 * of waiting for a refetch or an unrelated re-render.
 */
export function useNowTick(intervalMs = DEFAULT_TICK_MS): number {
    const [now, setNow] = useState(() => Date.now());
    useEffect(() => {
        const id = window.setInterval(() => setNow(Date.now()), intervalMs);
        return () => window.clearInterval(id);
    }, [intervalMs]);
    return now;
}
